import { InteractiveQuestionType } from '@genially/document-model';

import type { SelectedInteractiveQuestion } from '../SidebarSummary.context';
import { SidebarType } from '../types/SidebarType';

export const calculateSidebarTypeFromSelectedQuestion = (
  question?: SelectedInteractiveQuestion,
): SidebarType => {
  if (!question) {
    return SidebarType.Ranking;
  }

  switch (question.Type) {
    case InteractiveQuestionType.Survey:
      return SidebarType.Survey;
    case InteractiveQuestionType.OpenAnswer:
      return SidebarType.OpenAnswer;
    default:
      return SidebarType.Ranking;
  }
};
